// extracted by css-extract-rspack-plugin
export default {"CardBaseWithSash":"index-module__CardBaseWithSash__v6Jl5","dragDisabled":"index-module__dragDisabled__pnjNa","isRedacted":"index-module__isRedacted__Dcf6a"};